import { getGlobalEventsLogs } from '@cian/events-log';

import { subscribeOnAuthentification, TOPIC_USER } from './subscribeOnAuthentification';
import { IRequestAuthenticationParameters } from './types';
import { IThunkActionCreator } from '../../types/thunk';

interface IAuthenticateEvent {
  autoRefresh?: boolean;
}

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): IThunkActionCreator {
  return dispatch => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      const globalLog = getGlobalEventsLogs();

      dispatch(subscribeOnAuthentification(parameters));

      globalLog.produce<Required<IAuthenticateEvent>>(TOPIC_USER, {
        type: 'authenticate',
        value: {
          autoRefresh: false,
        },
      });
    }
  };
}
